export const routes = {
  home: '/',
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  cards: '/cards',
  trade: '/trade',
  tradeV2: '/trade-v2',
  rebirth: '/rebirth',
  community: '/community',
  collectors: '/collectors',
  profile: '/profile',
  settings: '/settings',
  wiki: '/wiki',
  daily: '/daily',
  blackMarket: '/black-market',
  communityEvent: '/community-event',
  store: '/store',
  notifications: '/notifications',
  cardScanner: '/card-scanner',
  messages: '/messages',
  chat: `/messages?conversation=${encodeURIComponent('__global_chat__')}`, // Chat global como conversa especial
  directMessages: '/messages', // Mensagens diretas
  ranking: '/ranking',
  termsAndPrivacy: '/legal/terms-and-privacy'
} as const 